import { toggleBodyScroll, transitionend } from '@/scripts/utils';
import { DOCUMENT_ELEMENT, SELECTORS } from '@/scripts/constants';

export default function (isOpened, scrollableSelector = null, modalElement, force) {
  const callback = () => {
    DOCUMENT_ELEMENT.classList.remove(SELECTORS.has_modal);
    toggleBodyScroll(false, scrollableSelector);
  };
  if (isOpened) {
    DOCUMENT_ELEMENT.classList.add(SELECTORS.has_modal);
    toggleBodyScroll(true, scrollableSelector);
  } else if (!force) {
    transitionend(modalElement, 'transitionend', () => {
      callback();
    });
  } else {
    callback();
  }
}



// WEBPACK FOOTER //
// ./scripts/utils/toggle-modal.js